<template>
    <el-row type="flex" justify="center">
        <el-col :sm="24" :md="16" :lg="12">
            <el-menu
                    :default-active="activeIndex"
                    class="el-menu-demo"
                    mode="horizontal"
                    background-color="#545c64"
                    text-color="#fff"
                    active-text-color="#ffd04b"
            >
                <el-menu-item index="1">
                    <el-link :underline="false" @click="jumpTo('#')" icon="el-icon-s-home">
                        ChenLinLab
                    </el-link>
                </el-menu-item>
                <el-submenu index="2">
                    <template slot="title">
                        <i class="el-icon-user-solid"></i>
                        {{$t('message.GroupMember')}}
                    </template>
                    <el-menu-item index="2-1">{{$t('message.Teacher')}}</el-menu-item>
                    <el-menu-item index="2-2">{{$t('message.PhD')}}</el-menu-item>
                    <el-menu-item index="2-3">{{$t('message.Master')}}</el-menu-item>
                </el-submenu>
                <el-menu-item index="3">
                    <template slot="title">
                        <i class="el-icon-document"></i>
                        {{$t('message.Publications')}}
                    </template>
                </el-menu-item>
                <el-submenu index="4">
                    <template slot="title">
                        <i class="el-icon-more"></i>
                        {{$t('message.Web')}}
                    </template>
                    <el-menu-item index="4-1">UCB</el-menu-item>
                    <el-menu-item index="4-2">Lung Cancer</el-menu-item>
                    <el-menu-item index="4-3"></el-menu-item>
                </el-submenu>

                <el-submenu index="5">
                    <template slot="title">
                        <i class="el-icon-setting"></i>
                        {{$t('message.Lang')}}
                    </template>
                    <el-menu-item v-for='(lang, idx) in langs' :key="lang" :index="'5-' + idx" @click="changeLang(lang)">{{ idx }}</el-menu-item>
                </el-submenu>
            </el-menu>

            <el-main>
                <router-view></router-view>
            </el-main>

            <el-divider></el-divider>

            <el-footer>
                <p>蜀ICP备20009228号</p>
                <p>© 2018 Sichuan University (四川大学)</p>
                <p>The Chenlinlab - State Key Laboratory of Biotherapy (生物治疗国家重点实验室)</p>
            </el-footer>

            <el-backtop target=".page-component__scroll .el-scrollbar__wrap"></el-backtop>
        </el-col>
    </el-row>
</template>

<script>
    export default {
        name: "App",
        data() {
            return {
                "activeIndex": '1',
                'langs': {
                    'English': 'en',
                    '简体中文': 'cn'
                }
            }
        },
        methods: {
            jumpTo: function(href) {
                window.location.replace(href)
            },
            changeLang: function(lang) {
                this.$i18n.locale = lang;
            }
        },
    }
</script>

<style scoped>
    .el-header {
        background-color: #409EFF;
        color: #333;
        line-height: 60px;
        padding-top: 0px;
    }
</style>